export default function BlogIndex() {
  const articles = [
    {
      title: 'How to Choose the Best Preschool in Chhatrapati Sambhaji Nagar',
      summary: 'Compare programs, routines, safety, communication and activity-based learning before choosing the right early learning environment.'
    },
    {
      title: 'What Age Should a Child Start Preschool?',
      summary: 'A preschool journey begins when your child is ready for group routines, social learning and age-appropriate classroom discovery.'
    },
    {
      title: 'Playgroup vs Nursery: What\'s the Difference?',
      summary: 'Playgroup and Nursery focus on early routines, confidence, language readiness, classroom participation and social development.'
    },
    {
      title: 'Why Phonics Is Important for Preschool Children',
      summary: 'Phonics helps children connect sounds, letters and spoken language as they begin early reading and communication skills.'
    },
    {
      title: 'How Activity-Based Learning Helps Young Children',
      summary: 'Hands-on classroom activities strengthen curiosity, creativity, confidence and meaningful learning in preschool years.'
    },
    {
      title: 'How to Prepare Your Child for the First Day of Preschool',
      summary: 'Simple routines, a friendly visit and positive parent communication can help children feel safe and ready for school.'
    },
    {
      title: 'Screen Time and Preschool Children: A Parent\'s Guide',
      summary: 'Balanced routines, outdoor play and conversation support healthy attention, early language and active learning.'
    },
    {
      title: '5 Ways Parents Can Support Early Learning at Home',
      summary: 'Conversation, stories, play, creativity and simple routines help children build language and confidence at home.'
    },
    {
      title: 'How Preschool Helps Develop Social Skills',
      summary: 'Preschool classrooms give children chances to listen, share, take turns, solve everyday situations and build friendships.'
    },
    {
      title: 'What Parents Should Look for in a Safe Preschool',
      summary: 'A safe preschool offers warm communication, clear routines, caring supervision and a child-friendly learning environment.'
    }
  ];

  return (
    <section id="blog" className="py-20 bg-white dark:bg-gray-900 transition-colors">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
            Parent Learning Guide
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Helpful early learning topics for families exploring preschool in Chhatrapati Sambhaji Nagar.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          {articles.map((article, idx) => (
            <article key={idx} className="bg-gradient-to-br from-pink-50 to-purple-50 dark:from-gray-800 dark:to-gray-700 rounded-2xl p-6 shadow-sm">
              <span className="text-pink-600 dark:text-pink-300 font-semibold text-sm">Parenting Guide</span>
              <h3 className="text-xl font-bold text-gray-900 dark:text-white mt-3 mb-2">{article.title}</h3>
              <p className="text-gray-600 dark:text-gray-300 text-sm">{article.summary}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
